module.exports = __webpack_public_path__ + "img/building95-5.15e39aa3.jpg";